import { defineEffect } from '../../../core/effect';
import { summonBank } from '../fx/summonBank';

/**
 * **反転召喚の effect**（Issue #581 v1 → #628 / #629 で分割。指示書 `../direction/flipsummoning.md`。キービジュアルは無い＝方向は人が決めた）。
 *
 * B 案（ユーザー 2026-09-28）: 盤のカードがその場で裏から表へ返り、そのあと通常召喚と同じバンク（`../fx/summonBank.js`）へつなぐ。
 * **裏返しは motion**（`flipsummoning_motion.js`。440ms）。同じ状況の帯は motion → effect の順に**重ならず**並ぶ
 * （`duelEditor/timeline/align.js` の sequential）ので、このファイルは待ちを持たず 0 からバンクを始める
 * —— 頭にも待ちを置くと 440ms が二重になり、開き終わってから何も起きない間ができる（!709 のレビューで指摘）。
 *
 * ```
 * （motion の帯 0〜440: 盤のカードが浮いて開く）
 * 0      バンク: 通常召喚の summoning と同じ。出発点は表に返ったばかりの盤のカード
 * 1400   終わり
 * ```
 */
export default defineEffect(summonBank({
  situation: 'flipsummoning',
  label: '反転召喚（軽い召喚バンク。開いたカードから）',
  color: '#ffb84a',
  tag: ['FLIP', 'SUMMON'],
}), 'flipsummoning_effect.js');
